import React from 'react';
import httpClientFactory from './httpClient';
import RESTDataProvider from './dataProvider';
import {  GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, UPDATE_MANY, DELETE, DELETE_MANY, DELETE_BATCH } from './dataProvider';
import sharedContext from '../sharedContext';

const DataAPIContext = React.createContext();
DataAPIContext.displayName = "DataAPIcontext";

/**
 * Wrap a data provider to inject franchise_to on all requests when a licensee is selected.
 * - GET_LIST / GET_ONE: appends ?franchise_to={id} via extra params
 * - CREATE: injects tour_operator into params.data
 * - `params.explicitTenant: true`: the call names its operator itself (`?franchise_to=` in its URL) and its body takes
 *   no other key -- the AI vocabulary's POST refuses `tour_operator` (400) -- so nothing is injected (the flag is
 *   dropped before the data provider, which would put it in a GET's query string).
 */
export const withFranchiseContext = (dp) => (type, resource, params) => {
    if (params && params.explicitTenant) {
        const { explicitTenant: _explicit, ...rest } = params;
        return dp(type, resource, rest);
    }
    const bootstrap = sharedContext.get('bootstrap');
    const isFranchise = bootstrap?.franchise?.is_franchise;
    const licenseeId = sharedContext.get('selected_licensee_id');

    if (isFranchise && licenseeId) {
        if (type === GET_LIST || type === GET_ONE || type === GET_MANY_REFERENCE) {
            params = { ...params, franchise_to: licenseeId };
        } else if (type === CREATE) {
            if (!params.data?.tour_operator) {
                params = {
                    ...params,
                    data: { ...params.data, tour_operator: licenseeId },
                };
            }
        }
    }
    return dp(type, resource, params);
};

const DataProviderFactory = (options) => {
    const httpClient = httpClientFactory(options.httpClient);
    const dp = RESTDataProvider(options.apiUrl, httpClient, options.provider);
    return withFranchiseContext(dp);
}

export {
    httpClientFactory,
    RESTDataProvider,
    DataAPIContext, DataProviderFactory,
    GET_LIST,
    GET_ONE,
    GET_MANY,
    GET_MANY_REFERENCE,
    CREATE,
    UPDATE,
    UPDATE_MANY,
    DELETE,
    DELETE_MANY,
    DELETE_BATCH
};
export default DataProviderFactory;
